import { render, staticRenderFns } from "./RemindModal.vue?vue&type=template&id=336fcbb0&scoped=true&"
import script from "./RemindModal.vue?vue&type=script&lang=js&"
export * from "./RemindModal.vue?vue&type=script&lang=js&"
import style0 from "./RemindModal.vue?vue&type=style&index=0&id=336fcbb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336fcbb0",
  null
  
)

export default component.exports